import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Card,
  Row,
  Col,
  Table,
  Button,
  Form,
  Modal,
  Dropdown,
} from "react-bootstrap";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { createRoutesFromElements, useNavigate, useParams } from "react-router-dom";
import APIServicenew from "../../utils/APIGeneralService";
import { UserContext } from "../../context/UserContextProvider";
import {
  formateDatemdy,
  capitalizeFirstLetter,
  capitalizeFirstLetterOfEveryWord,
} from "../../utils/Helper";
import { ToastContainer, toast } from "react-toastify";
import ApproveModel from "../../components/common/ApproveModel";
import DeleteModal from "../../components/common/DeleteModel";
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import { FaRegEye } from "react-icons/fa";
import { CiEdit } from "react-icons/ci";
import { FaCheck } from "react-icons/fa6";
import { MdOutlineDelete } from "react-icons/md";
import { FaRegQuestionCircle } from "react-icons/fa";
import { FaRegImage } from "react-icons/fa";
import { MdOutlineAudiotrack } from "react-icons/md";
import { GoVideo } from "react-icons/go";
import Paginator from "../../components/common/Pagination";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import useMenuPermissions from "../../components/CustomHook/custompermission";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";

const Lesson_details = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { "auth-token": authToken, authorization: accessToken };
  const [details, setDetails] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [countP, setCountP] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(12);
  const [activeTab, setActiveTab] = useState("details");
  const [status, setStatus] = useState(true);
  const [lessons, setLessons] = useState([]);
  const [lessonslist, setLessonslist] = useState([]);
  const [outline, setOutline] = useState("");
  const [content, setContent] = useState("");
  const [load, setLoad] = useState(false);
  const [loadQIAV, setLoadQIAV] = useState(false);
  const [loadEdit, setLoadEdit] = useState(false);
  const [errors, setErrors] = useState({});
  const [errorsE, setErrorsE] = useState({});
  const [selectedId, setSelectedId] = useState(null);
  const [lessonSingleData, setlessonSingleData] = useState({});
  const [show, setShow] = useState(false);
  const [showView, setShowView] = useState(false);
  const [showAppr, setShowAppr] = useState(false);
  const [showDt, setShowDt] = useState(false);
  const [showGtype, setShowGtype] = useState("");
  const [showQIAV, setshowQIAV] = useState(false);
  const [count, setCount] = useState(0);
  const [errorsQIAV, setErrorsQIAV] = useState({});
  const [quizList, setQuizList] = useState([]);
  const [imgList, setimgList] = useState([]);
  const [audioList, setaudioList] = useState([]);
  const [videoList, setvideoList] = useState([]);
  const [deleteType, setDeleteType] = useState();
  const [dNone, setDNone] = useState("");
  // Tabs_scroll
  const tabListRef = useRef(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);
  const permissionscontext = useMenuPermissions("/admin/lesson");

  const permissionscontextQuiz = useMenuPermissions("/admin/quiz");
  const permissionscontextImage = useMenuPermissions("/admin/image");
  const permissionscontextVideo = useMenuPermissions("/admin/video");
  const permissionscontextAudio = useMenuPermissions("/admin/audio");


  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isImageLoaded, setIsImageLoaded] = useState(true);
  const [filterLesson, setFilterLesson] = useState(0);
  const [selectedType, setSelectedType] = useState(null);

  const [showImageEdit, setShowImageEdit] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageText, setImageText] = useState("");
  const [errorsImage, setErrorsImage] = useState({});
  const [loadImageEdit, setLoadImageEdit] = useState(false);

  const [showVideoEdit, setShowVideoEdit] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [videoText, setVideoText] = useState("");
  const [errorsVideo, setErrorsVideo] = useState({});
  const [loadVideoEdit, setLoadVideoEdit] = useState(false);

  const [showImageUpload, setShowImageUpload] = useState(false);
  const [uploadLessonId, setUploadLessonId] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadErrors, setUploadErrors] = useState({});
  const [loadUpload, setLoadUpload] = useState(false);
  const [previewUrls, setPreviewUrls] = useState([]);

  const [showVideoUpload, setShowVideoUpload] = useState(false);
  const [uploadVideoLessonId, setUploadVideoLessonId] = useState("");
  const [selectedVideoFile, setSelectedVideoFile] = useState(null);
  const [videoUploadErrors, setVideoUploadErrors] = useState({});
  const [loadVideoUpload, setLoadVideoUpload] = useState(false);
  const [videoPreviewUrl, setVideoPreviewUrl] = useState("");

  // Image for Video states
  const [showImageForVideo, setShowImageForVideo] = useState(false);
  const [imageForVideoLessonId, setImageForVideoLessonId] = useState("");
  const [imageForVideoFile, setImageForVideoFile] = useState(null);
  const [imageForVideoPrompt, setImageForVideoPrompt] = useState("");
  const [imageForVideoPreview, setImageForVideoPreview] = useState("");
  const [imageForVideoErrors, setImageForVideoErrors] = useState({});
  const [loadImageForVideo, setLoadImageForVideo] = useState(false);

  const [expandedDescriptions, setExpandedDescriptions] = useState({});

  const toggleDescription = (itemId) => {
    setExpandedDescriptions(prev => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  const [imageDescription, setImageDescription] = useState("");
  const [videoDescription, setVideoDescription] = useState("");

  const handleImageLoad = () => {
    setIsImageLoaded(true);
  };

  const handleStatusChange = async (value) => {
    const newStatus = value === true ? "Active" : "Inactive";
    try {
      const payload = { lesson_id: id, status: newStatus };
      const res = await APIServices.put(
        `/admin/lessons/update/status`,
        payload,
        headers
      );
      if (res?.data?.status === true) {
        showToast(res?.data?.message || "Success", "success");
        setDetails({ ...details, status: newStatus });
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      showToast("Error updating status", "error");
    }
  };

  const openLightbox = (index) => {
    setPhotoIndex(index);
    setIsOpen(true);
    setIsImageLoaded(false);
  };

  useEffect(() => {
    const checkScroll = () => {
      const el = tabListRef.current;
      if (!el) return;
      const { scrollLeft, scrollWidth, clientWidth } = el;
      setShowLeft(scrollLeft > 0);
      setShowRight(scrollLeft + clientWidth < scrollWidth - 2);
    };

    checkScroll();
    const el = tabListRef.current;
    el?.addEventListener("scroll", checkScroll);
    window.addEventListener("resize", checkScroll);

    return () => {
      el?.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
    };
  }, []);

  const scrollTabs = (direction) => {
    const el = tabListRef.current;
    if (!el) return;
    const scrollAmount = 150;
    el.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedId(null);
    setErrorsE({});
    setDNone("")
  };

  const handleCloseQIAV = () => {
    setshowQIAV(false);
    setShowGtype("");
    setSelectedId(null);
    setCount(0);
    setErrorsQIAV({});
    setDNone("");
  };

  const handleCloseView = () => {
    setDNone("");
    setShowView(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "outline") {
      setOutline(value);
    } else if (name === "content") {
      setContent(value);
    }
    setErrorsE((prev) => ({
      ...prev,
      [name]: undefined,
    }));
  };

  // Filter tabs based on view permissions (details tab always visible)
  const getVisibleTabs = () => {
    const allTabs = [
      {
        key: "details",
        label: "Details",
        permission: true // Always visible
      },
      {
        key: "quizzes",
        label: `Quizzes ${details?.no_of_quiz !== 0 ? `(${details?.no_of_quiz})` : ""}`,
        permission: permissionscontextQuiz.view
      },
      {
        key: "images",
        label: `Images ${details?.no_of_image !== 0 ? `(${details?.no_of_image})` : ""}`,
        permission: permissionscontextImage.view
      },
      {
        key: "audios",
        label: `Audios ${details?.no_of_audio !== 0 ? `(${details?.no_of_audio})` : ""}`,
        permission: permissionscontextAudio.view
      },
      {
        key: "videos",
        label: `Videos ${details?.no_of_video !== 0 ? `(${details?.no_of_video})` : ""}`,
        permission: permissionscontextVideo.view
      },
    ];

    return allTabs.filter(tab => tab.permission);
  };

  const tabs = getVisibleTabs();

  // Set initial active tab based on permissions
  useEffect(() => {
    if (tabs.length > 0 && !tabs.some(tab => tab.key === activeTab)) {
      setActiveTab(tabs[0].key);
    }
  }, [tabs, activeTab]);

  useEffect(() => {
    fetchDetails(id);
  }, [id]);

  useEffect(() => {
    if (activeTab === "details") {
      lessonlist();
    } else if (activeTab === "quizzes") {
      lessonlist();
      fetchQuizDetails(currentPage, limit);
    } else if (activeTab === "audios") {
      lessonlist();
      fetchAudioDetails(currentPage, limit);
    } else if (activeTab === "images") {
      lessonlist();
      fetchImgDetails(currentPage, limit);
    } else if (activeTab === "videos") {
      lessonlist();
      fetchVideoDetails(currentPage, limit);
    }
  }, [activeTab, id, currentPage, limit]);

  // Effect to handle API calls when filterLesson or selectedType changes
  useEffect(() => {
    if (filterLesson && selectedType) {
      const fetchFunctions = {
        quiz: fetchQuizDetails,
        image: fetchImgDetails,
        audio: fetchAudioDetails,
        video: fetchVideoDetails
      };

      if (fetchFunctions[selectedType]) {
        fetchFunctions[selectedType](1, 12, filterLesson);
      }
    }
  }, [filterLesson, selectedType]);

  const handleSelectLesson = (lessonId, type) => {
    setCurrentPage(1);
    setFilterLesson(lessonId);
    setSelectedType(type);
  };

  const handleStatusChangeMedia = async (it, type) => {
    const newStatus = it.status === "Active" ? "Inactive" : "Active";
    try {
      const payload = { media_id: it.id, status: newStatus };
      const res = await APIServices.put(
        `/admin/media/status`,
        payload,
        headers
      );
      if (res?.data?.status === true) {
        showToast(res?.data?.message || "Success", "success");
        if (type === "image") {
          let updated = imgList.map((item) =>
            item.id === it.id ? { ...item, status: newStatus } : item
          );
          setimgList(updated);
        } else if (type === "audio") {
          let updated = audioList.map((item) =>
            item.id === it.id ? { ...item, status: newStatus } : item
          );
          setaudioList(updated);
        } else if (type === "video") {
          let updated = videoList.map((item) =>
            item.id === it.id ? { ...item, status: newStatus } : item
          );
          setvideoList(updated);
        }
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      showToast("Error updating status", "error");
    }
  };

  const handleStatusChangeQuiz = async (it) => {
    const newStatus = it.status === "Active" ? "Inactive" : "Active";
    try {
      const payload = { quiz_id: it.id, status: newStatus };
      const res = await APIServices.put(
        `/admin/quizzes/status`,
        payload,
        headers
      );
      if (res?.data?.status === true) {
        showToast(res?.data?.message || "Success", "success");
        let updated = quizList.map((item) =>
          item.id === it.id ? { ...item, status: newStatus } : item
        );
        setQuizList(updated);
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      showToast("Error updating status", "error");
    }
  };

  const fetchDetails = async (id) => {
    try {
      const response = await APIServices.get(
        `/admin/lessons/details/${id}`,
        headers
      );
      if (response?.status === 200) {
        setDetails(response?.data?.data?.lesson || {});
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setDetails({});
      }
    } catch (error) {
      setDetails({});
    }
  };

  const handleDelete = async () => {
    try {
      if (selectedId !== null) {
        if (deleteType == "lesson") {
          const payload = { id: selectedId };
          const res = await APIServices.put(
            `/admin/lessons/delete/${selectedId}`,
            payload,
            headers
          );
          if (res?.data?.status === true) {
            showToast(res?.data?.message || "Success", "success");
            const updated = lessons.filter((it) => it.id !== selectedId);
            setLessons(updated);
            handlePostDeletePagination(updated.length);
            setSelectedId(null);
            setShowDt(false);
            fetchDetails(id);
            setDNone("");
          } else {
            showToast(res?.data?.message || "Something went wrong.", "error");
            setDNone("");
          }
        }

        if (deleteType == "quiz") {
          const payload = { id: selectedId };
          const res = await APIServices.put(
            `/admin/quizzes/delete/${selectedId}`,
            payload,
            headers
          );

          if (res?.data?.status === true) {
            showToast(res?.data?.message || "Success", "success");
            const updated = quizList.filter((it) => it.id !== selectedId);
            setQuizList(updated);
            handlePostDeletePagination(updated.length);
            setSelectedId(null);
            setShowDt(false);
            fetchDetails(id);
            setDNone("");
          } else {
            showToast(res?.data?.message || "Something went wrong.", "error");
            setDNone("");
          }
        }

        if (
          deleteType == "image" ||
          deleteType == "audio" ||
          deleteType == "video"
        ) {
          const payload = { id: selectedId };
          const res = await APIServices.put(
            `/admin/media/delete/${selectedId}`,
            payload,
            headers
          );

          if (res?.data?.status === true) {
            showToast(res?.data?.message || "Success", "success");

            if (deleteType == "image") {
              let updated = imgList.filter((it) => it.id !== selectedId);
              setimgList(updated);
              handlePostDeletePagination(updated.length);
            } else if (deleteType == "audio") {
              let updated = audioList.filter((it) => it.id !== selectedId);
              setaudioList(updated);
              handlePostDeletePagination(updated.length);
            } else if (deleteType == "video") {
              let updated = videoList.filter((it) => it.id !== selectedId);
              setvideoList(updated);
              handlePostDeletePagination(updated.length);
            }

            setSelectedId(null);
            setShowDt(false);
            fetchDetails(id);
            setDNone("");
          } else {
            showToast(res?.data?.message || "Something went wrong.", "error");
            setDNone("");
          }
        }
      }
      setShowDt(false);
      setDNone("");
    } catch (error) {
      console.error("Error deleting:", error);
    }
  };

  const handlePostDeletePagination = (updatedListLength) => {
    if (updatedListLength === 0 && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const lessonlist = async () => {
    try {
      const response = await APIServices.get(
        `/admin/lessons/list`,
        headers
      );
      if (response?.status === 200) {
        const approvedLessons = response?.data?.data?.lessons?.filter(
          (lesson) => lesson.lesson_status === "Approved"
        ) || [];
        setLessonslist(approvedLessons);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setLessonslist([]);
      }
    } catch (error) {
      setLessonslist([]);
    }
  };

  const handleChangeQIAV = (e) => {
    const { name, value } = e.target;

    if (name === "count") {
      setCount(value);
    } else if (name === "lesson") {
      setSelectedId(value);
    }
    setErrorsQIAV((prev) => ({
      ...prev,
      [name]: undefined,
    }));
  };

  const handleGenerateQuiz = async (e) => {
    e.preventDefault();
    setFilterLesson(0)
    let newErrors = {};
    if (selectedId == null || selectedId === "") {
      newErrors.lesson = "Please select lesson.";
    }
    if (Number(count) === 0) {
      newErrors.count = "Please enter count.";
    }
    setErrorsQIAV(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return false;
    }
    setLoadQIAV(true);
    let newRow = { lesson_id: selectedId, no_of_question: Number(count) };
    try {
      const response = await APIServices.post(
        `/admin/quizzes/add`,
        newRow,
        headers
      );
      if (response?.data?.status === true) {
        showToast(response?.data?.message || "Success", "success");
        setLoadQIAV(false);
        fetchQuizDetails(currentPage, limit);
        fetchDetails(id);
        setshowQIAV(false);
        setDNone("");
      } else {
        showToast(response?.data?.message || "Something went wrong.", "error");
        setLoadQIAV(false);
        setDNone("");
      }
    } catch (error) {
      showToast("Something went wrong.", "error");
      setDNone("");
    } finally {
      setLoadQIAV(false);
      setDNone("");
    }
  };

  const handleGenerateImg = async (e) => {
    e.preventDefault();
    setFilterLesson(0)
    let newErrors = {};

    if (selectedId == null || selectedId === "") {
      newErrors.lesson = "Please select lesson.";
    }

    if (Number(count) === 0) {
      newErrors.count = "Please enter count.";
    }
    setErrorsQIAV(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return false;
    }
    setLoadQIAV(true);
    let newRow = {
      lesson_id: selectedId,
      no_of_images: Number(count),
      media_type: 2,
    };
    try {
      const response = await APIServices.post(
        `/admin/media/add`,
        newRow,
        headers
      );
      if (response?.data?.status === true) {
        showToast(response?.data?.message || "Success", "success");
        setLoadQIAV(false);
        fetchImgDetails(currentPage, limit);
        fetchDetails(id);
        setshowQIAV(false);
        setDNone("");
      } else {
        showToast(response?.data?.message || "Something went wrong.", "error");
        setLoadQIAV(false);
        setDNone("");
      }
    } catch (error) {
      showToast("Something went wrong.", "error");
      setDNone("");
    } finally {
      setLoadQIAV(false);
      setDNone("");
    }
  };

  const handleGenerateAudio = async (e) => {
    e.preventDefault();
    setFilterLesson(0)
    setLoadQIAV(true);
    let newErrors = {};
    if (selectedId == null || selectedId === "") {
      newErrors.lesson = "Please select lesson.";
    }
    setErrorsQIAV(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return false;
    }

    let newRow = { lesson_id: selectedId, media_type: 1 };
    try {
      const response = await APIServices.post(
        `/admin/media/add`,
        newRow,
        headers
      );
      if (response?.data?.status === true) {
        showToast(response?.data?.message || "Success", "success");
        setLoadQIAV(false);
        fetchAudioDetails(currentPage, limit);
        fetchDetails(id);
        setshowQIAV(false);
        setDNone("");
      } else {
        showToast(response?.data?.message || "Something went wrong.", "error");
        setLoadQIAV(false);
        setDNone("");
      }
    } catch (error) {
      showToast("Something went wrong.", "error");
      setDNone("");
      setLoadQIAV(false);
    } finally {
      setLoadQIAV(false);
      setDNone("");
    }
  };

  const handleGenerateVideo = async (e) => {
    e.preventDefault();
    setFilterLesson(0)
    setLoadQIAV(true);
    let newErrors = {};
    if (selectedId == null || selectedId === "") {
      newErrors.lesson = "Please select lesson.";
    }
    if (Number(count) === 0) {
      newErrors.count = "Please enter count.";
    }
    setErrorsQIAV(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return false;
    }

    let newRow = {
      lesson_id: selectedId,
      media_type: 3,
      no_of_images: Number(count),
    };
    try {
      const response = await APIServices.post(
        `/admin/media/add`,
        newRow,
        headers
      );
      if (response?.data?.status === true) {
        showToast(response?.data?.message || "Success", "success");
        setLoadQIAV(false);
        fetchVideoDetails(currentPage, limit);
        fetchDetails(id);
        setshowQIAV(false);
        setDNone("");
      } else {
        showToast(response?.data?.message || "Something went wrong.", "error");
        setLoadQIAV(false);
        setDNone("");
      }
    } catch (error) {
      showToast("Something went wrong.", "error");
      setDNone("");
    } finally {
      setDNone("");
      setLoadQIAV(false);
    }
  };

    const handleImageForVideoSelect = (e) => {
    const file = e.target.files[0];

    if (!file) {
      setImageForVideoFile(null);
      setImageForVideoPreview("");
      return;
    }

    if (!file.type.startsWith('image/')) {
      setImageForVideoErrors({ image: "Please select a valid image file" });
      e.target.value = '';
      return;
    }

    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      setImageForVideoErrors({ image: "Image size should be less than 10MB" });
      e.target.value = '';
      return;
    }

    setImageForVideoFile(file);
    setImageForVideoErrors({});

    if (imageForVideoPreview) {
      URL.revokeObjectURL(imageForVideoPreview);
    }
    const url = URL.createObjectURL(file);
    setImageForVideoPreview(url);
  };


  const handleGenerateQIAV = async (e) => {
    setFilterLesson(0)
    if (showGtype === "Quiz") {
      handleGenerateQuiz(e);
    } else if (showGtype === "Image") {
      handleGenerateImg(e);
    } else if (showGtype === "Audio") {
      handleGenerateAudio(e);
    } else if (showGtype === "Video") {
      handleGenerateVideo(e);
    }
  };

  const fetchQuizDetails = async (page, limit, lesson_id = 0) => {
    let skip = (page - 1) * limit;
    try {
      let url = `/admin/quizzes/list?lesson_id=${id}&skip=${skip}&limit=${limit}`;
      if (lesson_id > 0) {
        url += `&lesson_id=${lesson_id}`;
      } else if (filterLesson > 0) {
        url += `&lesson_id=${filterLesson}`;
      }
      const response = await APIServices.get(url, headers);
      if (response?.status === 200) {
        setQuizList(response?.data?.data?.quizzes || []);
        setTotal(response?.data?.data?.total || 0);
        setCountP(response?.data?.data?.total || 0);
        setTotalCount(Math.ceil((response?.data?.data?.total || 0) / limit) || 0);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setQuizList([]);
        setTotalCount(0);
      }
    } catch (error) {
      setQuizList([]);
      setTotalCount(0);
    }
  };

  const fetchImgDetails = async (page, limit, lesson_id = 0) => {
    let skip = (page - 1) * limit;
    try {
      let url = `/admin/media/list?lesson_id=${id}&media_type=2&skip=${skip}&limit=${limit}`;
      if (lesson_id > 0) {
        url += `&lesson_id=${lesson_id}`;
      } else if (filterLesson > 0) {
        url += `&lesson_id=${filterLesson}`;
      }
      const response = await APIServices.get(url, headers);
      if (response?.status === 200) {
        setimgList(response?.data?.data?.media || []);
        setTotal(response?.data?.data?.total || 0);
        setCountP(response?.data?.data?.total || 0);
        setTotalCount(Math.ceil((response?.data?.data?.total || 0) / limit) || 0);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setimgList([]);
        setTotalCount(0);
      }
    } catch (error) {
      setimgList([]);
      setTotalCount(0);
    }
  };

  const fetchAudioDetails = async (page, limit, lesson_id = 0) => {
    let skip = (page - 1) * limit;
    try {
      let url = `/admin/media/list?lesson_id=${id}&media_type=1&skip=${skip}&limit=${limit}`;
      if (lesson_id > 0) {
        url += `&lesson_id=${lesson_id}`;
      } else if (filterLesson > 0) {
        url += `&lesson_id=${filterLesson}`;
      }

      const response = await APIServices.get(url, headers);
      if (response?.status === 200) {
        setaudioList(response?.data?.data?.media || []);
        setTotal(response?.data?.data?.total || 0);
        setCountP(response?.data?.data?.total || 0);
        setTotalCount(Math.ceil((response?.data?.data?.total || 0) / limit) || 0);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setaudioList([]);
        setTotalCount(0);
      }
    } catch (error) {
      setaudioList([]);
      setTotalCount(0);
    }
  };

  const fetchVideoDetails = async (page, limit, lesson_id = 0) => {
    let skip = (page - 1) * limit;
    try {
      let url = `/admin/media/list?lesson_id=${id}&media_type=3&skip=${skip}&limit=${limit}`;
      if (lesson_id > 0) {
        url += `&lesson_id=${lesson_id}`;
      } else if (filterLesson > 0) {
        url += `&lesson_id=${filterLesson}`;
      }
      const response = await APIServices.get(url, headers);
      if (response?.status === 200) {
        setvideoList(response?.data?.data?.media || []);
        setTotal(response?.data?.data?.total || 0);
        setCountP(response?.data?.data?.total || 0);
        setTotalCount(Math.ceil((response?.data?.data?.total || 0) / limit) || 0);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setvideoList([]);
        setTotalCount(0);
      }
    } catch (error) {
      setvideoList([]);
      setTotalCount(0);
    }
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };

  const handleImageEdit = async () => {
    let newErrors = {};
    if (!imageText?.trim()) {
      newErrors.text = "Please enter image text/description.";
    }

    setErrorsImage(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return false;
    }

    setLoadImageEdit(true);

    try {
      if (selectedImage?.id) {
        const payload = {
          media_id: selectedImage.id,
          description: imageText
        };

        const res = await APIServices.put(
          `/admin/media/update_description`,
          payload,
          headers
        );

        if (res?.data?.status === true) {
          showToast(res?.data?.message || "Image updated successfully", "success");

          const updatedImages = imgList.map(item =>
            item.id === selectedImage.id ? { ...item, description: imageText } : item
          );
          setimgList(updatedImages);

          setShowImageEdit(false);
          setSelectedImage(null);
          setImageText("");
          setErrorsImage({});
          setDNone("");
        } else {
          showToast(res?.data?.message || "Something went wrong.", "error");
        }
      }
    } catch (error) {
      console.error("Error updating image:", error);
      showToast("Error updating image", "error");
    } finally {
      setLoadImageEdit(false);
    }
  };

  const handleVideoEdit = async () => {
    let newErrors = {};
    if (!videoText?.trim()) {
      newErrors.text = "Please enter video text/description.";
    }

    setErrorsVideo(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return false;
    }

    setLoadVideoEdit(true);

    try {
      if (selectedVideo?.id) {
        const payload = {
          media_id: selectedVideo.id,
          description: videoText
        };

        const res = await APIServices.put(
          `/admin/media/update_description`,
          payload,
          headers
        );

        if (res?.data?.status === true) {
          showToast(res?.data?.message || "Video updated successfully", "success");

          const updatedVideos = videoList.map(item =>
            item.id === selectedVideo.id ? { ...item, description: videoText } : item
          );
          setvideoList(updatedVideos);

          setShowVideoEdit(false);
          setSelectedVideo(null);
          setVideoText("");
          setErrorsVideo({});
          setDNone("");
        } else {
          showToast(res?.data?.message || "Something went wrong.", "error");
        }
      }
    } catch (error) {
      console.error("Error updating video:", error);
      showToast("Error updating video", "error");
    } finally {
      setLoadVideoEdit(false);
    }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];

    if (!file) {
      setSelectedFiles([]);
      setPreviewUrls([]);
      return;
    }

    if (!file.type.startsWith('image/')) {
      setUploadErrors({ files: "Please select a valid image file" });
      e.target.value = '';
      return;
    }

    setSelectedFiles([file]);
    setUploadErrors({});

    if (previewUrls.length > 0) {
      URL.revokeObjectURL(previewUrls[0]);
    }
    const url = URL.createObjectURL(file);
    setPreviewUrls([url]);
  };

  const removeFile = (index) => {
    const newFiles = [...selectedFiles];
    const newUrls = [...previewUrls];

    URL.revokeObjectURL(newUrls[index]);

    newFiles.splice(index, 1);
    newUrls.splice(index, 1);

    setSelectedFiles(newFiles);
    setPreviewUrls(newUrls);
  };

  const handleImageUpload = async () => {
    let newErrors = {};

    if (selectedFiles.length === 0) {
      newErrors.files = "Please select an image";
    }

    setUploadErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return false;
    }

    setLoadUpload(true);

    try {
      const formData = new FormData();
      formData.append('lesson_id', id);
      formData.append('description', imageDescription || '');
      formData.append('media_type', 'image');
      formData.append('media_file', selectedFiles[0]);

      const uploadHeaders = {
        ...headers,
        'Content-Type': 'multipart/form-data'
      };

      const res = await APIServices.post(
        `/admin/media/upload_media`,
        formData,
        uploadHeaders
      );

      if (res?.data?.status === true) {
        showToast(res?.data?.message || "Image uploaded successfully", "success");
        fetchImgDetails(currentPage, limit);
        fetchDetails(id);

        setShowImageUpload(false);
        setSelectedFiles([]);
        setPreviewUrls([]);
        setUploadErrors({});
        setImageDescription("");
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      showToast("Error uploading image", "error");
    } finally {
      setLoadUpload(false);
    }
  };

  useEffect(() => {
    return () => {
      previewUrls.forEach(url => URL.revokeObjectURL(url));
    };
  }, [previewUrls]);

  const handleVideoFileSelect = (e) => {
    const file = e.target.files[0];

    if (!file) {
      setSelectedVideoFile(null);
      setVideoPreviewUrl("");
      return;
    }

    if (!file.type.startsWith('video/')) {
      setVideoUploadErrors({ video: "Please select a valid video file" });
      e.target.value = '';
      return;
    }

    const maxSize = 50 * 1024 * 1024;
    if (file.size > maxSize) {
      setVideoUploadErrors({ video: "Video size should be less than 50MB" });
      e.target.value = '';
      return;
    }

    setSelectedVideoFile(file);
    setVideoUploadErrors({});

    if (videoPreviewUrl) {
      URL.revokeObjectURL(videoPreviewUrl);
    }
    const url = URL.createObjectURL(file);
    setVideoPreviewUrl(url);
  };


  const handleImageForVideoUpload = async () => {
    let newErrors = {};


    if (!imageForVideoFile) {
      newErrors.image = "Please select an image";
    }

    if (!imageForVideoPrompt?.trim()) {
      newErrors.prompt = "Please enter a prompt description";
    }

    setImageForVideoErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return false;
    }

    setLoadImageForVideo(true);

    try {
      const formData = new FormData();
      formData.append('lesson_id', id);
      formData.append('prompt', imageForVideoPrompt);
      formData.append('media_type', 'Image');
      formData.append('media_file', imageForVideoFile);

      const uploadHeaders = {
        ...headers,
        'Content-Type': 'multipart/form-data'
      };

      const res = await APIServices.post(
        `/admin/media/upload_temp_media`,
        formData,
        uploadHeaders
      );

      if (res?.data?.status === true) {
        showToast(res?.data?.message || "Image uploaded successfully for video creation", "success");
        fetchVideoDetails(currentPage, limit);
        fetchDetails(id);
        setShowImageForVideo(false);
        setImageForVideoLessonId("");
        setImageForVideoFile(null);
        setImageForVideoPrompt("");
        setImageForVideoPreview("");
        setImageForVideoErrors({});
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Error uploading image for video:", error);
      showToast("Error uploading image for video", "error");
    } finally {
      setLoadImageForVideo(false);
    }
  };

  const handleVideoUpload = async () => {
    let newErrors = {};

    if (!selectedVideoFile) {
      newErrors.video = "Please select a video file";
    }

    setVideoUploadErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return false;
    }

    setLoadVideoUpload(true);

    try {
      const formData = new FormData();
      formData.append('lesson_id', id);
      formData.append('description', videoDescription || '');
      formData.append('media_type', 'video');
      formData.append('media_file', selectedVideoFile);

      const uploadHeaders = {
        ...headers,
        'Content-Type': 'multipart/form-data'
      };

      const res = await APIServices.post(
        `/admin/media/upload_media`,
        formData,
        uploadHeaders
      );

      if (res?.data?.status === true) {
        showToast(res?.data?.message || "Video uploaded successfully", "success");
        fetchVideoDetails(currentPage, limit);
        fetchDetails(id);

        setShowVideoUpload(false);
        setSelectedVideoFile(null);
        setVideoPreviewUrl("");
        setVideoUploadErrors({});
        setVideoDescription("");
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Error uploading video:", error);
      showToast("Error uploading video", "error");
    } finally {
      setLoadVideoUpload(false);
    }
  };

  useEffect(() => {
    return () => {
      if (videoPreviewUrl) {
        URL.revokeObjectURL(videoPreviewUrl);
      }
    };
  }, [videoPreviewUrl]);

  const getCollapsedText = (text) => {
    if (!text) return "";
    const firstLine = text.split("\n")[0];
    return firstLine.length > 50
      ? firstLine.substring(0, 50) + "..."
      : firstLine;
  };

  return (
    <>
      <div className="topic_details_inner">
        <Row>
          <Col lg={12}>
            <h2 className="font_blue_18 font-600 mb-3">{details?.sr_no} {details?.name}</h2>
            <Card className="TD_box">
              <Card.Header>
                <Row>
                  {/* First Row: Topic Name (8) and Create Date (4) */}
                  <Col xxl={12} xl={12} lg={12} md={12}>
                    <div className="d-flex ky">
                      <h4 className="font_blue_16 font-500 mb-0">Topic Name <span>:</span></h4>
                      <p className="font_blue_16">{details?.topic_name || "N/A"}</p>
                    </div>
                  </Col>

                  {/* Third Row: Approved by (4), Lesson Status (4), Status (4) */}
                  <Col xxl={3} xl={3} lg={3} md={3} className="mt-3">
                    <div className="d-flex ky">
                      <h4 className="font_blue_16 font-500 mb-0">Approved by <span>:</span></h4>
                      <p className="font_blue_16">{details?.approved_by || "N/A"}</p>
                    </div>
                  </Col>

                  <Col xxl={3} xl={3} lg={3} md={3} className="mt-3">
                    <div className="d-flex ky">
                      <h4 className="font_blue_16 font-500 mb-0">Lesson Status <span>:</span></h4>
                      <p className="font_blue_16">
                        <span className={`status-text ${details?.lesson_status === "Approved"
                          ? "success"
                          : details?.lesson_status === "Pending"
                            ? "warning"
                            : "secondary"
                          }`}>
                          {details?.lesson_status || "N/A"}
                        </span>
                      </p>
                    </div>
                  </Col>

                  <Col xxl={3} xl={3} lg={3} md={3} className="mt-3">
                    <div className="d-flex ky">
                      <h4 className="font_blue_16 font-500 mb-0">Status <span>:</span></h4>
                      <Form className="Switch_toggle">
                        <input
                          type="checkbox"
                          id="status-switch"
                          checked={details?.status === "Active"}
                          onChange={(e) => handleStatusChange(e.target.checked)}
                          disabled={!permissionscontext.edit}
                        />
                        <label
                          htmlFor="status-switch"
                          className="position-relative"
                        >
                          Toggle
                        </label>
                      </Form>
                    </div>
                  </Col>
                  <Col xxl={3} xl={3} lg={3} md={3} className="mt-3">
                    <div className="d-flex ky">
                      <h4 className="font_blue_16 font-500 mb-0">Create Date <span>:</span></h4>
                      <p className="font_blue_16">
                        {details?.created_at ? formateDatemdy(details.created_at) : "N/A"}
                      </p>
                    </div>
                  </Col>
                </Row>
              </Card.Header>
              <Card.Body>
                {/* Tabs Navigation - Only shows tabs with view permission (details always visible) */}
                {tabs.length > 0 && (
                  <div className="position-relative td_scroll_tab mt-3 mb-3">
                    {showLeft && (
                      <button
                        onClick={() => scrollTabs("left")}
                        className="position-absolute start-0 top-50 translate-middle-y bg-white border-0 shadow p-1 z-3"
                      >
                        <FaAngleLeft />
                      </button>
                    )}

                    <ul
                      ref={tabListRef}
                      className="nav nav-tabs flex-nowrap overflow-auto hide-scrollbar"
                    >
                      {tabs.map((tab) => (
                        <li key={tab.key} className="nav-item flex-shrink-0">
                          <button
                            className={`nav-link ${activeTab === tab.key ? "active" : ""
                              } whitespace-nowrap`}
                            onClick={() => {
                              setActiveTab(tab.key);
                              setCurrentPage(1);
                            }}
                          >
                            {tab.label}
                          </button>
                        </li>
                      ))}
                    </ul>

                    {showRight && (
                      <button
                        onClick={() => scrollTabs("right")}
                        className="position-absolute end-0 top-50 translate-middle-y bg-white border-0 shadow p-1 z-3"
                      >
                        <FaAngleRight />
                      </button>
                    )}
                  </div>
                )}

                <div className="tab-contents">

                  {/* Details Tab - Always visible */}
                  {activeTab === "details" && (
                    <div className="tab-pane detail">
                      <Row>
                        <Col lg={12}>
                          <Card.Body>
                            <div className="d-flex ky">
                              <div
                                className="right w-100"
                                dangerouslySetInnerHTML={{
                                  __html: details?.lesson_text || "",
                                }}
                              ></div>
                            </div>
                          </Card.Body>
                        </Col>
                      </Row>
                    </div>
                  )}

                  {/* Quizzes Tab - With permission checks */}
                  {activeTab === "quizzes" && permissionscontextQuiz.view && (
                    <div className="tab-pane quizzes">
                      <div className="d-flex align-items-center justify-content-end lession_dropdown mb-3 gap-2">
                        {details?.lesson_status == "Approved" && permissionscontextQuiz.add && (
                          <Button
                            type="button"
                            className="btn red_button d-flex align-items-center"
                            style={{ height: "38px" }}
                            onClick={() => {
                              setshowQIAV(true);
                              setShowGtype("Quiz");
                              setSelectedId(id);
                              setCount(5);
                              setErrorsQIAV({});
                            }}
                          >
                            Generate Quiz
                          </Button>
                        )}
                      </div>

                      <Row>
                        {quizList && quizList?.length !== 0 ? (
                          quizList?.map((quiz, index) => (
                            <Col md={6} lg={6} xxl={4} key={quiz.id}>
                              <Card className="mb-3">
                                <Card.Body className="position-relative">
                                  <div className="btn_sec">
                                    <Form className="Switch_toggle">
                                      <input
                                        type="checkbox"
                                        id={`switch-${quiz.id}`}
                                        checked={quiz.status === "Active"}
                                        onChange={() => handleStatusChangeQuiz(quiz)}
                                        disabled={!permissionscontextQuiz.edit}
                                      />
                                      <label
                                        className="position-relative"
                                        htmlFor={`switch-${quiz.id}`}
                                      >
                                        Toggle
                                      </label>
                                    </Form>
                                    {permissionscontextQuiz.delete && (
                                      <button
                                        className="btn p-0 text-danger"
                                        onClick={() => {
                                          setSelectedId(quiz.id);
                                          setShowDt(true);
                                          setDeleteType("quiz");
                                        }}
                                      >
                                        <FaTrash />
                                      </button>
                                    )}
                                  </div>
                                  <h5 className="font_blue_18 font-600 mb-3">
                                    {quiz.sr_no}.{(currentPage - 1) * limit + index + 1}. {quiz.question}
                                  </h5>
                                  <ul className="d-flex align-items-center flex-wrap mb-3">
                                    <li className="w-50">
                                      <p className="font_blue_16">
                                        1. {quiz?.options?.option1}
                                      </p>
                                    </li>
                                    <li className="w-50">
                                      <p className="font_blue_16">
                                        2. {quiz?.options?.option2}
                                      </p>
                                    </li>
                                    <li className="w-50">
                                      <p className="font_blue_16">
                                        3. {quiz?.options?.option3}
                                      </p>
                                    </li>
                                    <li className="w-50">
                                      <p className="font_blue_16">
                                        4. {quiz?.options?.option4}
                                      </p>
                                    </li>
                                  </ul>
                                  <p className="font_blue_18 blue_clr">
                                    <strong>Answer:</strong> {quiz?.answer}
                                  </p>
                                  <p className="font_blue_18 blue_clr mt-2">
                                    <strong>Lesson Name :</strong> {quiz?.lesson_name}
                                  </p>
                                </Card.Body>
                              </Card>
                            </Col>
                          ))
                        ) : (
                          <div className="d-flex align-items-center justify-content-center mt-5 w-100">
                            <h4>No Quizzes Available</h4>
                          </div>
                        )}
                      </Row>
                    </div>
                  )}

                  {/* Images Tab - With permission checks */}
                  {activeTab === "images" && permissionscontextImage.view && (
                    <div className="tab-pane tab_images">
                      <div className="d-flex align-items-center justify-content-end gap-2 mb-3">
                        {details?.lesson_status == "Approved" && permissionscontextImage.add && (
                          <Button
                            type="button"
                            className="btn red_button d-flex align-items-center"
                            style={{ height: "38px" }}
                            onClick={() => {
                              setshowQIAV(true);
                              setShowGtype("Image");
                              setSelectedId(id);
                              setCount(5);
                              setErrorsQIAV({});
                            }}
                          >
                            Generate Images
                          </Button>
                        )}
                        {permissionscontextImage.add && (
                          <Button
                            type="button"
                            className="btn red_button d-flex align-items-center"
                            style={{ height: "38px" }}
                            onClick={() => {
                              setShowImageUpload(true);
                              setUploadLessonId("");
                              setSelectedFiles([]);
                              setPreviewUrls([]);
                              setUploadErrors({});
                            }}
                          >
                            Upload Image
                          </Button>
                        )}
                      </div>
                      <Row>
                        {imgList && imgList?.length !== 0 ? (
                          imgList?.map((item, i) => (
                            <Col lg={4} md={6} sm={6} key={item.id} className="mb-3">
                              <Card className="position-relative image-card p-2">
                                <div className="btn_sec">
                                  <Form className="Switch_toggle">
                                    <input
                                      type="checkbox"
                                      id={`switch-${item.id}`}
                                      checked={item.status === "Active"}
                                      onChange={() => handleStatusChangeMedia(item, "image")}
                                      disabled={!permissionscontextImage.edit}
                                    />
                                    <label
                                      className="position-relative"
                                      htmlFor={`switch-${item.id}`}
                                    >
                                      Toggle
                                    </label>
                                  </Form>

                                  {permissionscontextImage.edit && (
                                    <button
                                      className="btn p-0 text-primary mx-2"
                                      onClick={() => {
                                        setSelectedImage(item);
                                        setImageText(item?.description || "");
                                        setShowImageEdit(true);
                                        setDNone("d-none");
                                      }}
                                    >
                                      <FaEdit size={18} />
                                    </button>
                                  )}

                                  {permissionscontextImage.delete && (
                                    <button
                                      className="btn p-0 text-danger"
                                      onClick={() => {
                                        setSelectedId(item.id);
                                        setShowDt(true);
                                        setDeleteType("image");
                                      }}
                                    >
                                      <FaTrash />
                                    </button>
                                  )}
                                </div>
                                <div
                                  style={{ cursor: "pointer" }}
                                  onClick={() => openLightbox(i)}
                                >
                                  {item?.media_url && item?.media_url.trim() !== "" ? (
                                    <Card.Img
                                      variant="top"
                                      src={item?.media_url}
                                      className="img-fluid"
                                      alt=""
                                    />
                                  ) : item?.media_status === "Pending" ? (
                                    <div className="preparing-placeholder d-flex align-items-center justify-content-center bg-light"
                                      style={{ height: "282px", borderRadius: "4px" }}>
                                      <div className="text-center">
                                        <div className="spinner-border text-primary mb-2" role="status" style={{ width: "2rem", height: "2rem" }}>
                                          <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="mb-0 text-muted fw-medium">Preparing Image...</p>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="image-placeholder d-flex align-items-center justify-content-center bg-light"
                                      style={{ height: "282px", borderRadius: "4px" }}>
                                      <p className="text-muted mb-0">No image available</p>
                                    </div>
                                  )}
                                </div>
                                {item?.description && (
                                  <div className="description-container mt-2">
                                    {!expandedDescriptions[item.id] ? (
                                      <>
                                        <span className="description-text">
                                          {getCollapsedText(item.description)}
                                        </span>

                                        {item.description.length > 50 && (
                                          <a
                                            href="#"
                                            className="show-more-link"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              e.stopPropagation();
                                              toggleDescription(item.id);
                                            }}
                                          >
                                            {" "}show more
                                          </a>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <span className="description-text">
                                          {item.description}
                                        </span>
                                        <a
                                          href="#"
                                          className="show-more-link"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            toggleDescription(item.id);
                                          }}
                                        >
                                          {" "}show less
                                        </a>
                                      </>
                                    )}
                                  </div>
                                )}
                                <p className="font_blue_14 font-500 mt-2 line-climb2">
                                  {item?.sr_no}.{(currentPage - 1) * limit + i + 1} {item?.lesson_name}
                                </p>
                              </Card>
                            </Col>
                          ))
                        ) : (
                          <div className="d-flex align-items-center justify-content-center mt-5 w-100">
                            <h4>No Images Available</h4>
                          </div>
                        )}
                      </Row>

                      {isOpen && (
                        <Lightbox
                          mainSrc={imgList[photoIndex]?.media_url}
                          nextSrc={imgList[(photoIndex + 1) % imgList.length]?.media_url}
                          prevSrc={imgList[(photoIndex + imgList.length - 1) % imgList.length]?.media_url}
                          onCloseRequest={() => setIsOpen(false)}
                          onImageLoad={handleImageLoad}
                          onMovePrevRequest={() =>
                            setPhotoIndex((photoIndex + imgList.length - 1) % imgList.length)
                          }
                          onMoveNextRequest={() =>
                            setPhotoIndex((photoIndex + 1) % imgList.length)
                          }
                          enableZoom={true}
                          reactModalStyle={{
                            overlay: { zIndex: 2000 },
                          }}
                          imageTitle={`Image ${photoIndex + 1} of ${imgList.length}`}
                        />
                      )}
                    </div>
                  )}

                  {/* Videos Tab - With permission checks */}
                  {activeTab === "videos" && permissionscontextVideo.view && (
                    <div className="tab-pane tab_videos">
                      <div className="d-flex align-items-center justify-content-end gap-2 mb-3">
                        {details?.lesson_status == "Approved" && permissionscontextVideo.add && (
                          <>
                            <Button
                              type="button"
                              title="Upload image for create video"
                              className="btn red_button d-flex align-items-center"
                              style={{ height: "38px" }}
                              onClick={() => {
                                setShowImageForVideo(true);
                                setImageForVideoLessonId("");
                                setImageForVideoFile(null);
                                setImageForVideoPrompt("");
                                setImageForVideoPreview("");
                                setImageForVideoErrors({});
                                setSelectedId(id);
                              }}
                            >
                              Image to Video
                            </Button>

                            <Button
                              type="button"
                              className="btn red_button d-flex align-items-center"
                              style={{ height: "38px" }}
                              onClick={() => {
                                setshowQIAV(true);
                                setShowGtype("Video");
                                setSelectedId(id);
                                setCount(1);
                                setErrorsQIAV({});
                              }}
                            >
                              Generate AI Video
                            </Button>
                          </>
                        )}
                        {permissionscontextVideo.add && (
                          <Button
                            type="button"
                            className="btn red_button d-flex align-items-center"
                            style={{ height: "38px" }}
                            onClick={() => {
                              setShowVideoUpload(true);
                              setUploadVideoLessonId("");
                              setSelectedVideoFile(null);
                              setVideoPreviewUrl("");
                              setVideoUploadErrors({});
                            }}
                          >
                            Upload Video
                          </Button>
                        )}
                      </div>

                      <Row>
                        {videoList && videoList?.length !== 0 ? (
                          videoList?.map((item, i) => (
                            <Col lg={4} md={6} sm={6} key={item.id} className="mb-3">
                              <Card className="position-relative image-card p-2">
                                <div className="btn_sec">
                                  <Form className="Switch_toggle">
                                    <input
                                      type="checkbox"
                                      id={`switch-${item.id}`}
                                      checked={item.status === "Active"}
                                      onChange={() => handleStatusChangeMedia(item, "video")}
                                      disabled={!permissionscontextVideo.edit}
                                    />
                                    <label
                                      className="position-relative"
                                      htmlFor={`switch-${item.id}`}
                                    >
                                      Toggle
                                    </label>
                                  </Form>

                                  {permissionscontextVideo.edit && (
                                    <button
                                      className="btn p-0 text-primary mx-2"
                                      onClick={() => {
                                        setSelectedVideo(item);
                                        setVideoText(item?.description || "");
                                        setShowVideoEdit(true);
                                        setDNone("d-none");
                                      }}
                                    >
                                      <FaEdit size={18} />
                                    </button>
                                  )}

                                  {permissionscontextVideo.delete && (
                                    <button
                                      className="btn p-0 text-danger"
                                      onClick={() => {
                                        setSelectedId(item.id);
                                        setShowDt(true);
                                        setDeleteType("video");
                                      }}
                                    >
                                      <FaTrash />
                                    </button>
                                  )}
                                </div>

                                {item?.media_url && item?.media_url.trim() !== "" ? (
                                  <video width="100%" controls>
                                    <source
                                      src={item?.media_url}
                                      type="video/mp4"
                                    />
                                    Your browser does not support the video tag.
                                  </video>
                                ) : item?.media_status === "Pending" ? (
                                  <div className="preparing-placeholder d-flex align-items-center justify-content-center bg-light"
                                    style={{ height: "250px", borderRadius: "4px" }}>
                                    <div className="text-center">
                                      <div className="spinner-border text-primary mb-2" role="status" style={{ width: "2rem", height: "2rem" }}>
                                        <span className="visually-hidden">Loading...</span>
                                      </div>
                                      <p className="mb-0 text-muted fw-medium">Preparing video...</p>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="video-placeholder d-flex align-items-center justify-content-center bg-light"
                                    style={{ height: "250px", borderRadius: "4px" }}>
                                    <p className="text-muted mb-0">No video available</p>
                                  </div>
                                )}

                                {item?.description && (
                                  <div className="description-container mt-2">
                                    {!expandedDescriptions[item.id] ? (
                                      <>
                                        <span className="description-text">
                                          {getCollapsedText(item.description)}
                                        </span>

                                        {item.description.length > 50 && (
                                          <a
                                            href="#"
                                            className="show-more-link"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              e.stopPropagation();
                                              toggleDescription(item.id);
                                            }}
                                          >
                                            {" "}show more
                                          </a>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <span className="description-text">
                                          {item.description}
                                        </span>
                                        <a
                                          href="#"
                                          className="show-more-link"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            toggleDescription(item.id);
                                          }}
                                        >
                                          {" "}show less
                                        </a>
                                      </>
                                    )}
                                  </div>
                                )}

                                <p className="font_size_14 font-500 mt-2 line-climb2">
                                  {item?.sr_no}.{(currentPage - 1) * limit + i + 1} {item?.lesson_name}
                                </p>
                              </Card>
                            </Col>
                          ))
                        ) : (
                          <div className="d-flex align-items-center justify-content-center mt-5 w-100">
                            <h4>No Videos Available</h4>
                          </div>
                        )}
                      </Row>
                    </div>
                  )}

                  {/* Audios Tab - With permission checks */}
                  {activeTab === "audios" && permissionscontextAudio.view && (
                    <div className="tab-pane tab_audio">
                      <div className="d-flex align-items-center justify-content-end lession_dropdown mb-3 gap-2">
                        {details?.lesson_status == "Approved" && permissionscontextAudio.add && (
                          <Button
                            type="button"
                            className="btn red_button d-flex align-items-center"
                            style={{ height: "38px" }}
                            onClick={() => {
                              setshowQIAV(true);
                              setShowGtype("Audio");
                              setSelectedId(id);
                              setErrorsQIAV({});
                            }}
                          >
                            Generate Audio
                          </Button>
                        )}
                      </div>
                      <Row>
                        {audioList && audioList?.length !== 0 ? (
                          audioList?.map((item, i) => (
                            <Col lg={4} md={6} sm={6} key={item.id}>
                              <div className="mb-3">
                                <Card className="position-relative p-2">
                                  <div className="btn_sec">
                                    <Form className="Switch_toggle">
                                      <input
                                        type="checkbox"
                                        id={`switch-${item.id}`}
                                        checked={item.status === "Active"}
                                        onChange={() => handleStatusChangeMedia(item, "audio")}
                                        disabled={!permissionscontextAudio.edit}
                                      />
                                      <label
                                        className="position-relative"
                                        htmlFor={`switch-${item.id}`}
                                      >
                                        Toggle
                                      </label>
                                    </Form>
                                    {permissionscontextAudio.delete && (
                                      <button
                                        className="btn py-1 text-danger"
                                        onClick={() => {
                                          setSelectedId(item.id);
                                          setShowDt(true);
                                          setDeleteType("audio");
                                        }}
                                      >
                                        <FaTrash />
                                      </button>
                                    )}
                                  </div>

                                  <audio controls>
                                    <source
                                      src={item?.media_url}
                                      type="audio/mpeg"
                                    />
                                  </audio>

                                  <p className="font_blue_14 font-500 mt-2 line-climb2">
                                    {item?.sr_no}.{(currentPage - 1) * limit + i + 1} {item?.lesson_name}
                                  </p>
                                </Card>
                              </div>
                            </Col>
                          ))
                        ) : (
                          <div className="d-flex align-items-center justify-content-center mt-5 w-100">
                            <h4>No Audios Available</h4>
                          </div>
                        )}
                      </Row>
                    </div>
                  )}
                </div>

                <div className="pagination_box mt-4">
                  {countP > limit && (
                    <Paginator
                      currentPage={currentPage}
                      totalPages={totalCount}
                      onPageChange={handlePageChange}
                    />
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      <ToastContainer />

      {/* Generate Modal */}
      <Modal
        show={showQIAV}
        size="md"
        onHide={handleCloseQIAV}
        centered
        backdrop="static"
        className="add_subproduct msl_model"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="font_blue_20 font-600">
            Generate {showGtype}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <Row className="mb-3 font_blue_18">
            <Col md={12} className="mb-3">
              <Form.Group
                as={Row}
                controlId="Lesson"
                className="align-items-center"
              >
                <Form.Label
                  column
                  sm={3}
                  className="font_blue_14 font-500 mb-0 text-end"
                >
                  Lesson :
                </Form.Label>
                <Col sm={9}>
                  <Form.Select
                    name="lesson"
                    value={selectedId}
                    onChange={(e) => handleChangeQIAV(e)}
                    readOnly
                    disabled
                    className="bg-light"
                  >
                    <option value="">Select Lesson</option>
                    {lessonslist && lessonslist.map((lesson) => (
                      <option key={lesson.id} value={lesson.id}>
                        <b>{lesson.sr_no}</b> {lesson.name}
                      </option>
                    ))}
                  </Form.Select>
                  {errorsQIAV.lesson && (
                    <div className="invalid-feedback d-block">
                      {errorsQIAV.lesson}
                    </div>
                  )}
                </Col>
              </Form.Group>
            </Col>

            {showGtype !== "Audio" && (
              <Col md={12} className="mb-3">
                <Form.Group
                  as={Row}
                  controlId="count"
                  className="align-items-center"
                >
                  <Form.Label
                    column
                    sm={3}
                    className="font_blue_14 font-500 mb-0 text-end"
                  >
                    {`Number of ${showGtype}`} :
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      type="number"
                      name="count"
                      placeholder="count"
                      value={count}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (/^\d*$/.test(val)) {
                          handleChangeQIAV(e);
                        }
                      }}
                      min="1"
                      step="1"
                      isInvalid={!!errorsQIAV.count}
                    />
                    {errorsQIAV.count && (
                      <div className="invalid-feedback d-block">
                        {errorsQIAV.count}
                      </div>
                    )}
                  </Col>
                </Form.Group>
              </Col>
            )}
          </Row>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="warning"
            className="success_btn"
            onClick={handleGenerateQIAV}
            disabled={loadQIAV}
          >
            {loadQIAV ? "Processing..." : "Generate"}
          </Button>
          <Button
            variant="secondary"
            className="cancel_btn"
            onClick={handleCloseQIAV}
            disabled={loadQIAV}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Image Edit Modal */}
      <Modal
        show={showImageEdit}
        size="sm"
        onHide={() => {
          setShowImageEdit(false);
          setDNone("");
          setSelectedImage(null);
          setImageText("");
          setErrorsImage({});
        }}
        centered
        backdrop="static"
        className="add_subproduct msl_model"
      >
        <Modal.Header closeButton className="border-0 pb-1">
          <Modal.Title className="font_blue_18 font-600">
            Edit Image Text/Description
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12}>
              <div className="text-center mb-3">
                <p className="font_blue_14 font-500 mt-2">
                  {selectedImage?.sr_no}. {selectedImage?.lesson_name}
                </p>
                <img
                  src={selectedImage?.media_url}
                  alt="Selected"
                  className="img-fluid rounded w-50 mt-2"
                  style={{ objectFit: "contain" }}
                />
              </div>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label className="font_blue_14 font-500">
                  Image Text/Description
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={imageText}
                  onChange={(e) => {
                    setImageText(e.target.value);
                    setErrorsImage({});
                  }}
                  placeholder="Enter text for this image..."
                  isInvalid={!!errorsImage.text}
                  style={{ minHeight: "100px" }}
                />
                {errorsImage.text && (
                  <div className="invalid-feedback d-block">
                    {errorsImage.text}
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="warning"
            className="success_btn"
            onClick={handleImageEdit}
            disabled={loadImageEdit}
          >
            {loadImageEdit ? "Updating..." : "Update"}
          </Button>
          <Button
            variant="secondary"
            className="cancel_btn"
            onClick={() => {
              setShowImageEdit(false);
              setDNone("");
              setSelectedImage(null);
              setImageText("");
              setErrorsImage({});
            }}
            disabled={loadImageEdit}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Video Edit Modal */}
      <Modal
        show={showVideoEdit}
        size="md"
        onHide={() => {
          setShowVideoEdit(false);
          setDNone("");
          setSelectedVideo(null);
          setVideoText("");
          setErrorsVideo({});
        }}
        centered
        backdrop="static"
        className="add_subproduct msl_model"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="font_blue_20 font-600">
            Edit Video
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center mb-3">
            <video width="100%" controls>
              <source
                src={selectedVideo?.media_url}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
            <p className="font_blue_14 font-500 mt-2">
              {selectedVideo?.sr_no}. {selectedVideo?.lesson_name}
            </p>
          </div>

          <Form.Group className="mb-3">
            <Form.Label className="font_blue_14 font-500">
              Video Text/Description
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={videoText}
              onChange={(e) => {
                setVideoText(e.target.value);
                setErrorsVideo({});
              }}
              placeholder="Enter text for this video..."
              isInvalid={!!errorsVideo.text}
              style={{ minHeight: "100px" }}
            />
            {errorsVideo.text && (
              <div className="invalid-feedback d-block">
                {errorsVideo.text}
              </div>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="warning"
            className="success_btn"
            onClick={handleVideoEdit}
            disabled={loadVideoEdit}
          >
            {loadVideoEdit ? "Updating..." : "Update"}
          </Button>
          <Button
            variant="secondary"
            className="cancel_btn"
            onClick={() => {
              setShowVideoEdit(false);
              setDNone("");
              setSelectedVideo(null);
              setVideoText("");
              setErrorsVideo({});
            }}
            disabled={loadVideoEdit}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Image Upload Modal */}
      <Modal
        show={showImageUpload}
        size="md"
        onHide={() => {
          setShowImageUpload(false);
          setSelectedFiles([]);
          setPreviewUrls([]);
          setUploadErrors({});
          setImageDescription("");
        }}
        centered
        backdrop="static"
        className="add_subproduct msl_model"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="font_blue_20 font-600">
            Upload Image
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12} className="mb-3">
              <div className="d-flex ky">
                <h4 className="font_blue_14 font-500 mb-0">Lesson <span>:</span></h4>
                <p className="font_blue_14 ms-2 fw-bold">{details?.sr_no} {details?.name || "N/A"}</p>
              </div>
            </Col>

            <Col md={12} className="mb-3">
              <Form.Group>
                <Form.Label className="font_blue_14 font-500">
                  Choose Image <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={handleFileSelect}
                  isInvalid={!!uploadErrors.files}
                />
                {uploadErrors.files && (
                  <div className="invalid-feedback d-block">
                    {uploadErrors.files}
                  </div>
                )}
                <Form.Text className="text-muted">
                  Allowed formats: JPG
                </Form.Text>
              </Form.Group>
            </Col>

            {previewUrls.length > 0 && (
              <Col md={12}>
                <div className="mt-2">
                  <p className="font_blue_12 mb-1">Preview:</p>
                  <div className="position-relative d-inline-block">
                    <img
                      src={previewUrls[0]}
                      alt="Preview"
                      style={{
                        width: '150px',
                        height: '150px',
                        objectFit: 'cover',
                        borderRadius: '4px',
                        border: '1px solid #ddd'
                      }}
                    />
                    <button
                      type="button"
                      className="position-absolute top-0 end-0 bg-danger text-white border-0 rounded-circle"
                      style={{
                        width: '20px',
                        height: '20px',
                        fontSize: '12px',
                        lineHeight: '1',
                        padding: '0',
                        transform: 'translate(50%, -50%)'
                      }}
                      onClick={() => {
                        setSelectedFiles([]);
                        setPreviewUrls([]);
                      }}
                    >
                      ×
                    </button>
                  </div>
                </div>
              </Col>
            )}

            <Col md={12} className="mb-3">
              <Form.Group>
                <Form.Label className="font_blue_14 font-500">
                  Image Description
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={imageDescription}
                  onChange={(e) => {
                    setImageDescription(e.target.value);
                    setUploadErrors({});
                  }}
                  placeholder="Enter description for this image..."
                  style={{ minHeight: "100px" }}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="warning"
            className="success_btn"
            onClick={handleImageUpload}
            disabled={loadUpload}
          >
            {loadUpload ? "Uploading..." : "Upload"}
          </Button>
          <Button
            variant="secondary"
            className="cancel_btn"
            onClick={() => {
              setShowImageUpload(false);
              setSelectedFiles([]);
              setPreviewUrls([]);
              setUploadErrors({});
              setImageDescription("");
            }}
            disabled={loadUpload}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Video Upload Modal */}
      <Modal
        show={showVideoUpload}
        size="md"
        onHide={() => {
          setShowVideoUpload(false);
          setSelectedVideoFile(null);
          setVideoPreviewUrl("");
          setVideoUploadErrors({});
          setVideoDescription("");
        }}
        centered
        backdrop="static"
        className="add_subproduct msl_model"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="font_blue_20 font-600">
            Upload Video
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12} className="mb-3">
              <div className="d-flex ky">
                <h4 className="font_blue_14 font-500 mb-0">Lesson <span>:</span></h4>
                <p className="font_blue_14 ms-2 fw-bold">{details?.sr_no} {details?.name || "N/A"}</p>
              </div>
            </Col>

            <Col md={12} className="mb-3">
              <Form.Group>
                <Form.Label className="font_blue_14 font-500">
                  Choose Video <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="file"
                  accept="video/mp4,video/mpeg,video/quicktime"
                  onChange={handleVideoFileSelect}
                  isInvalid={!!videoUploadErrors.video}
                />
                {videoUploadErrors.video && (
                  <div className="invalid-feedback d-block">
                    {videoUploadErrors.video}
                  </div>
                )}
                <Form.Text className="text-muted">
                  Allowed formats: MP4 Max size: 50MB
                </Form.Text>
              </Form.Group>
            </Col>

            {videoPreviewUrl && (
              <Col md={12}>
                <div className="mt-2">
                  <p className="font_blue_12 mb-1">Preview:</p>
                  <div className="position-relative">
                    <video
                      width="100%"
                      controls
                      style={{ maxHeight: "200px" }}
                    >
                      <source src={videoPreviewUrl} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                    <button
                      type="button"
                      className="position-absolute top-0 end-0 bg-danger text-white border-0 rounded-circle"
                      style={{
                        width: '20px',
                        height: '20px',
                        fontSize: '12px',
                        lineHeight: '1',
                        padding: '0',
                        transform: 'translate(50%, -50%)'
                      }}
                      onClick={() => {
                        setSelectedVideoFile(null);
                        setVideoPreviewUrl("");
                      }}
                    >
                      ×
                    </button>
                  </div>
                </div>
              </Col>
            )}

            <Col md={12} className="mb-3">
              <Form.Group>
                <Form.Label className="font_blue_14 font-500">
                  Video Description
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={videoDescription}
                  onChange={(e) => {
                    setVideoDescription(e.target.value);
                    setVideoUploadErrors({});
                  }}
                  placeholder="Enter description for this video..."
                  style={{ minHeight: "100px" }}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="warning"
            className="success_btn"
            onClick={handleVideoUpload}
            disabled={loadVideoUpload}
          >
            {loadVideoUpload ? "Uploading..." : "Upload"}
          </Button>
          <Button
            variant="secondary"
            className="cancel_btn"
            onClick={() => {
              setShowVideoUpload(false);
              setSelectedVideoFile(null);
              setVideoPreviewUrl("");
              setVideoUploadErrors({});
              setVideoDescription("");
            }}
            disabled={loadVideoUpload}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Upload Image for Video Modal */}
      <Modal
        show={showImageForVideo}
        size="md"
        onHide={() => {
          setShowImageForVideo(false);
          setImageForVideoLessonId("");
          setImageForVideoFile(null);
          setImageForVideoPrompt("");
          setImageForVideoPreview("");
          setImageForVideoErrors({});
          if (imageForVideoPreview) {
            URL.revokeObjectURL(imageForVideoPreview);
          }
        }}
        centered
        backdrop="static"
        className="add_subproduct msl_model"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="font_blue_20 font-600">
            Upload Image for Video Creation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12} className="mb-3">
              <Form.Group>
                <Form.Label className="font_blue_14 font-500">
                  Select Lesson <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  value={selectedId}
                  onChange={(e) => {
                    setImageForVideoLessonId(e.target.value);
                    setImageForVideoErrors({});
                  }}
                  readOnly
                  disabled
                >
                  <option value="">Select Lesson</option>
                  {lessonslist && lessonslist.map((lesson) => (
                    <option key={lesson.id} value={lesson.id}>
                      <b>{lesson.sr_no}</b> {lesson.name}
                    </option>
                  ))}
                </Form.Select>
              
              </Form.Group>
            </Col>

            <Col md={12} className="mb-3">
              <Form.Group>
                <Form.Label className="font_blue_14 font-500">
                  Choose Image <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={handleImageForVideoSelect}
                  isInvalid={!!imageForVideoErrors.image}
                />
                {imageForVideoErrors.image && (
                  <div className="invalid-feedback d-block">
                    {imageForVideoErrors.image}
                  </div>
                )}
                <Form.Text className="text-muted">
                  Allowed formats: JPG Max size: 10MB
                </Form.Text>
              </Form.Group>
            </Col>

            {imageForVideoPreview && (
              <Col md={12} className="mb-3">
                <div className="mt-2">
                  <p className="font_blue_12 mb-1">Preview:</p>
                  <div className="position-relative d-inline-block">
                    <img
                      src={imageForVideoPreview}
                      alt="Preview"
                      style={{
                        width: '200px',
                        height: '200px',
                        objectFit: 'cover',
                        borderRadius: '4px',
                        border: '1px solid #ddd'
                      }}
                    />
                    <button
                      type="button"
                      className="position-absolute top-0 end-0 bg-danger text-white border-0 rounded-circle"
                      style={{
                        width: '20px',
                        height: '20px',
                        fontSize: '12px',
                        lineHeight: '1',
                        padding: '0',
                        transform: 'translate(50%, -50%)'
                      }}
                      onClick={() => {
                        setImageForVideoFile(null);
                        setImageForVideoPreview("");
                      }}
                    >
                      ×
                    </button>
                  </div>
                </div>
              </Col>
            )}

            <Col md={12} className="mb-3">
              <Form.Group>
                <Form.Label className="font_blue_14 font-500">
                  Prompt <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={imageForVideoPrompt}
                  onChange={(e) => {
                    setImageForVideoPrompt(e.target.value);
                    setImageForVideoErrors({});
                  }}
                  placeholder="Enter prompt description for video creation..."
                  isInvalid={!!imageForVideoErrors.prompt}
                  style={{ minHeight: "100px" }}
                />
                {imageForVideoErrors.prompt && (
                  <div className="invalid-feedback d-block">
                    {imageForVideoErrors.prompt}
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="warning"
            className="success_btn"
            onClick={handleImageForVideoUpload}
            disabled={loadImageForVideo}
          >
            {loadImageForVideo ? "Uploading..." : "Upload Image"}
          </Button>
          <Button
            variant="secondary"
            className="cancel_btn"
            onClick={() => {
              setShowImageForVideo(false);
              setImageForVideoLessonId("");
              setImageForVideoFile(null);
              setImageForVideoPrompt("");
              setImageForVideoPreview("");
              setImageForVideoErrors({});
              if (imageForVideoPreview) {
                URL.revokeObjectURL(imageForVideoPreview);
              }
            }}
            disabled={loadImageForVideo}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <DeleteModal
        showdt={showDt}
        handleCloseDt={() => {
          setShowDt(false);
          setDNone("");
        }}
        handledelete={handleDelete}
      />
    </>
  );
};

export default Lesson_details;